(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$rootScopeProvider'];

    /**
     * Created by vimpans on 2019/7/3
     */

    function stateConfig($stateProvider) {
        $stateProvider
            .state('building', {
                parent: 'module',
                url: '/building?:keyword',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/building/building.html',
                        controller: 'BuildingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('buildingDetail', {
                parent: 'module',
                url: '/building-d?:id',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/building/building-detail.html',
                        controller: 'BuildingDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
